;(function ($) {
  const ajax_object = tei_ajax_object
  let currentPage = 2

  function updateUrl(params) {
    const url = new URL(window.location)
    Object.entries(params).forEach(([key, value]) => {
      if (value) url.searchParams.set(key, value)
      else url.searchParams.delete(key)
    })
    window.history.replaceState({}, "", url)
  }

  function getUrlParams() {
    const params = {}
    const searchParams = new URLSearchParams(window.location.search)
    for (const [key, value] of searchParams.entries()) params[key] = value
    return params
  }

  function getMoreItems({ maxPages, pageFunction, loadingAnimation, originalText, term, pageLang, order }) {
    const data = {
      action: pageFunction,
      page: currentPage,
      tax: term || "",
      order: order || "DESC",
      lang: pageLang || "et",
    }

    $.ajax({
      type: "post",
      dataType: "json",
      url: ajax_object.ajax_url,
      data,
      success(response) {
        const $newItems = $(response.data)
        $(".js-items").append($newItems)
        if ($newItems.length) $newItems.first().attr("tabindex", "-1").focus()
        currentPage++
        clearInterval(loadingAnimation)
        if (currentPage > Number(maxPages)) $(".pagination").fadeOut(300)
        else $(".js-get-more-items").text(originalText)
      },
      error(MLHttpRequest, textStatus, errorThrown) {
        console.log({ MLHttpRequest, textStatus, errorThrown })
      },
    })
  }

  function updatePostsLegend() {
    const $postsCount = $(".js-posts-count")
    const $postsLegend = $(".js-posts-legend")
    if ($postsCount.length && $postsLegend.length) {
      const count = parseInt($postsCount.text(), 10)
      const singularText = $postsLegend.data("singular")
      const pluralText = $postsLegend.data("plural")
      $postsLegend.text(count === 1 ? singularText : pluralText)
    }
  }

  

  function fetchFilteredItems() {
    const order = $("#order").val() || "DESC"
    const term = $("#filter").val()
  
    const types = $(".type-button.is-active")
      .map(function () {
        return $(this).data("type")
      })
      .get()
  
    const action =
      $("#order option:selected").data("function") ||
      $("#filter option:selected").data("function") ||
      $(".type-button.is-active").first().data("function") ||
      "default_function"
  
    const rawLang = document.documentElement.lang || "et"
    const currentLang = rawLang.split("-")[0]
  
    updateUrl({
      order,
      filter: term,
      type: types.join(","),
    })
  
    currentPage = 2
  
    $.ajax({
      type: "post",
      dataType: "json",
      url: ajax_object.ajax_url,
      data: {
        action,
        order,
        tax: term,
        type: types,
        lang: currentLang,
        page: 1,
      },
      success(response) {
        const { maxPages, postCount, data } = response
        const $pagination = $(".pagination")
        const $loadMoreData = $(".js-get-more-items")
        const $postsCount = $(".js-posts-count")
        const $items = $(".js-items")
        const $noResults = $(".no-results")
      
        $loadMoreData.attr({
          "data-max-pages": maxPages,
          "data-order": order,
          "data-filter": term,
          "data-type": types.join(","),
        })
      
        $postsCount.text(postCount)
        updatePostsLegend()
      
        $items.html(data)
      
        if (postCount === 0) {
          $items.hide()
          $noResults.fadeIn(200)
          $(".participants-list").addClass("no-results-found")
          $pagination.hide()
        } else {
          $noResults.hide()
          $(".participants-list").removeClass("no-results-found")
          $pagination.show()
          $items.fadeIn(200)
        }
      
        if (maxPages) {
          currentPage > maxPages
            ? $pagination.fadeOut(300)
            : $pagination.fadeIn(300)
        }
      },
      error(err) {
        console.log(err)
      },
    })
  }
  
  

  $(document).on("change", "#order, #filter", fetchFilteredItems)
  $(document).on("click", ".type-button", function () {
    $(this).toggleClass("is-active")
  
    const types = $(".type-button.is-active")
      .map(function () {
        return $(this).data("type")
      })
      .get()
  
    $("#type").val(types.join(",")) // optional legacy support
  
    fetchFilteredItems()
  })
  

  $(document).on("click", ".js-get-more-items", function () {
    const $this = $(this)
    const maxPages = $this.data("max-pages")
    const pageFunction = $this.data("function")
    const pageLang = $this.data("lang")
    const order = $this.data("order")
    const filter = $this.data("filter")
    const originalText = $this.text()

    let loadingText = 0
    const loadingTexts = document.documentElement.lang === "et"
      ? ["Laeb", "Laeb.", "Laeb..", "Laeb..."]
      : ["Loading", "Loading.", "Loading..", "Loading..."]

    const loadingAnimation = setInterval(() => {
      $this.text(loadingTexts[loadingText])
      loadingText = (loadingText + 1) % 4
    }, 500)

    getMoreItems({ maxPages, pageFunction, loadingAnimation, originalText, term: filter, pageLang, order })
  })

  $(document).ready(function () {
    const $loadMoreData = $(".js-get-more-items")
    const maxPages = $loadMoreData.data("max-pages")
    if (maxPages === 1) $(".pagination").hide()

    const params = getUrlParams()
    if (Object.keys(params).length) {
      if (params.filter) $("#filter").val(params.filter)
      if (params.order) $("#order").val(params.order)
      if (params.type) $("#type").val(params.type)
      fetchFilteredItems()
    }
  })
})(jQuery)
